import React from 'react';
import styled from '@emotion/styled';
import { useDispatch, useI18n } from '~/Hooks';
import navigateLeftIcon from '~/Assets/icons/navigate-left.svg';
import * as actions from '~/actions';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  padding: 60px;
  width: 100vw;
  height: 100vh;
  z-index: 99999;
  background: #1c232c;
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: auto;
`;

const Content = styled.div`
  text-align: left;
  font-size: 22px;
  color: #fff;
  padding-left: 40px;
  box-sizing: border-box;
  font-weight: bold;
  padding: 30px;
  border-radius: 4px;
  background-color: #2f353d;
  max-width: 80%;
`;

const Title = styled.div``;

const InfoText = styled.pre`
  font-size: 18px;
  color: #b0b3b6;
  margin-top: 20px;
  white-space: break-spaces;
`;

const BackButton = styled.div`
  position: absolute;
  top: 40px;
  left: 20px;
  color: #fff;
  display: flex;
  align-items: center;
  font-size: 16px;
  opacity: 0.1;
`;

const BackButtonIcon = styled.div`
  width: 32px;
  height: 32px;
  mask-image: url(${navigateLeftIcon});
  mask-size: contain;
  mask-repeat: no-repeat;
  background-color: #fff;
  margin-right: 8x;
`;

interface Props {
  stack: string;
  onClick: () => void;
}

const CriticalError: React.FunctionComponent<Props> = ({ stack, children, onClick }) => {
  const { i18n } = useI18n();
  const dispatch = useDispatch();

  const goBack = () => {
    onClick();

    // Reset the last visited path to avoid being stuck on a broken url
    dispatch({ type: actions.SET_LAST_VISITED_PATH, path: '' });
    window.location.href = '/'; // history.push does not work here because it is outside of the router context, that's why we use window.location.href
  };

  return (
    <Wrapper>
      <BackButton onClick={goBack}>
        <BackButtonIcon />
        {i18n('General.GoBack')}
      </BackButton>
      <Content>
        {__DEV__ ? (
          <>
            <Title>{children}</Title>
            <InfoText>
              <small>{stack || i18n('Error.NoErrorInfo')}</small>
            </InfoText>
          </>
        ) : (
          <>
            <Title>{i18n('Error.SomethingWrong')}</Title>

            <InfoText>{i18n('Error.AskHelp')}</InfoText>
          </>
        )}
      </Content>
    </Wrapper>
  );
};

export default CriticalError;
